<script lang="ts" setup>
import { UIcon } from "#components";
</script>

<template>
  <div class="fixed right-0 top-0 z-50">
    <UTooltip text="Non-Production">
      <div
        class="flex
             items-center p-[2px] opacity-50 hover:opacity-100"
      >
        <UIcon
          name="i-ph-warning"
          class="bg-primary-900 size-5 md:size-6"
        />
      </div>
    </UTooltip>
  </div>
</template>

<style scoped>
</style>
